<template>
  <div class="content-wrapper">
    <section class="content-customers pt-5">
      <div
        data-cy="AccSet"
        class="container"
      >
        <h2>Account Settings</h2>

        <ul class="nav nav-tabs settings-container__tab-container">
          <li class="nav-item">
            <a
              data-cy="AccInf"
              href="#"
              class="nav-link settings-container__nav-link"
              :class="{ active: tab == 'ACCOUNT' }"
              role="tab"
              @click.prevent="tab = 'ACCOUNT'"
            >Account Information</a>
          </li>
          <li class="nav-item">
            <a
              href="#"
              class="nav-link settings-container__nav-link"
              role="tab"
              :class="{ active: tab == 'PRACTICE' }"
              @click.prevent="tab = 'PRACTICE'"
            >Practice Details</a>
          </li>
        </ul>

        <form @submit.prevent="saveAccount">
          <div
            v-if="tab == 'ACCOUNT'"
            class="tab-content"
          >
            <div
              id="account-info"
              class="tab-pane active"
              role="tabpanel"
            >
              <div class="settings-container__parent-container">
                <div class="settings-container__form col-sm-10">
                  <div class="row">
                    <div class="col col-sm-3 d-none d-sm-block" />
                    <h4 class="settings-container__main-header col-sm-9">
                      Account Information
                    </h4>
                  </div>
                  <div
                    class="form-group row string required user_first_name"
                    aria-required="true"
                  >
                    <label
                      class="col-sm-3 form-control-label col-form-label string required"
                      for="user_first_name"
                      aria-required="true"
                    >
                      <span
                        title="required"
                        style="color: red"
                      >*</span> First
                      Name
                    </label>
                    <div class="col-sm-8">
                      <input
                        id="user_first_name"
                        v-model="profile.firstName"
                        v-validate="'required'"
                        data-cy="firstName"
                        name="firstName"
                        data-vv-scope="profileForm"
                        :class="{
                          'is-invalid': errors.first('profileForm.firstName')
                        }"
                        class="form-control string required valid"
                        autofocus="autofocus"
                        required="required"
                        aria-required="true"
                        type="text"
                        autocomplete="off"
                        aria-invalid="false"
                      >
                      <div
                        data-cy="invalidFirstName"
                        class="invalid-feedback"
                      >
                        Please provide your first name
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group row string required user_last_name"
                    aria-required="true"
                  >
                    <label
                      class="col-sm-3 form-control-label col-form-label string required"
                      for="user_last_name"
                      aria-required="true"
                    >
                      <span
                        title="required"
                        style="color: red"
                      >*</span> Last
                      Name</label>
                    <div class="col-sm-8">
                      <input
                        id="user_last_name"
                        v-model="profile.lastName"
                        v-validate="'required'"
                        data-cy="lastName"
                        name="lastName"
                        data-vv-scope="profileForm"
                        :class="{
                          'is-invalid': errors.first('profileForm.lastName')
                        }"
                        class="form-control string required"
                        required="required"
                        aria-required="true"
                        type="text"
                      >
                      <div
                        data-cy="invalidLastName"
                        class="invalid-feedback"
                      >
                        Please provide your last name
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group row email required user_email"
                    aria-required="true"
                  >
                    <label
                      class="col-sm-3 form-control-label col-form-label email required"
                      for="user_email"
                      aria-required="true"
                    >
                      <span
                        title="required"
                        style="color: red"
                      >*</span> Email
                      Address</label>
                    <div
                      data-cy="emailAddr"
                      class="col-sm-8"
                    >
                      <input
                        id="user_email"
                        v-model="profile.email"
                        v-validate="'required|email'"
                        class="form-control string email required"
                        name="email"
                        data-vv-scope="profileForm"
                        :class="{
                          'is-invalid': errors.first('profileForm.email')
                        }"
                        required="required"
                        aria-required="true"
                        type="email"
                        readonly
                      >
                      <div
                        data-cy="invalidEmailAddr"
                        class="invalid-feedback"
                      >
                        Please provide a valid email
                      </div>
                    </div>
                  </div>

                  <h5
                    class="settings-container__sub-header col-sm-9 offset-sm-3 mtxl mt-5 mb-4"
                  >
                    Change your password
                  </h5>
                  <div class="form-group row password optional user_password">
                    <label
                      class="col-sm-3 form-control-label col-form-label password optional"
                      for="user_password"
                    >Current password</label>
                    <div class="col-sm-8">
                      <input
                        id="user_password"
                        v-model="profile.password"
                        data-cy="PWfield"
                        class="form-control password optional"
                        type="password"
                        name="user[password]"
                        @input="currentPasswordError=''"
                      >
                      <div
                        v-if="currentPasswordError"
                        class="text-red py-3"
                      >
                        <span>{{ currentPasswordError }}</span>
                      </div>
                    </div>
                  </div>
                  <Password
                    :new-password.sync="profile.newPassword"
                    :confirm-password.sync="profile.reEnteredPassword"
                    @passwordValidation="passwordValidation($event)"
                  >
                    <template v-slot:password>
                      <div
                        class="form-group row password optional user_password_confirmation"
                      >
                        <label
                          class="col-sm-3 form-control-label col-form-label password optional"
                          for="user_password_confirmation"
                        >New Password</label>
                        <div class="col-sm-8">
                          <input
                            id="user_password_confirmation"
                            v-model="profile.newPassword"
                            data-cy="confPWfield"
                            class="form-control password optional"
                            type="password"
                            name="user[password_confirmation]"
                          >
                          <template
                            v-if="!validPassword && profile.newPassword"
                          >
                            <span class="text-red py-3">{{ newPasswordError }}</span>
                          </template>
                        </div>
                      </div>
                      <div
                        class="form-group row password optional user_password_reconfirmation"
                      >
                        <label
                          class="col-sm-3 form-control-label col-form-label password optional"
                          for="user_password_reconfirmation"
                        >Re-enter New Password</label>
                        <div class="col-sm-8">
                          <input
                            id="user_password_reconfirmation"
                            v-model="profile.reEnteredPassword"
                            class="form-control password optional"
                            type="password"
                            name="user[password_reconfirmation]"
                          >
                          <template v-if="confirmPasswordError">
                            <span class="text-red py-3">{{ confirmPasswordError }}</span>
                          </template>
                        </div>
                      </div>
                      <div
                        v-if="profile.newPassword"
                        class="row"
                      >
                        <div class="col col-sm-3 hidden-sm-down" />
                        <div class="col-12 row pt-2">
                          <div class="col-sm-3 form-control-label">
                            Password Strength
                          </div>
                          <div class="col-sm-7">
                            <PasswordStrength
                              v-model="profile.newPassword"
                              :strength-meter-only="true"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                  </Password>
                  <div class="form-actions col-sm-9 offset-sm-3">
                    <input
                      :disabled="isButtonDisabled"
                      data-cy="submit"
                      type="submit"
                      name="commit"
                      value="Save changes"
                      class="btn btn-primary settings-container__submit-btn mtl"
                      data-disable-with="Save changes"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <form @submit.prevent="savePractice">
          <div
            v-if="tab == 'PRACTICE'"
            class="tab-content"
          >
            <div
              id="practice-info"
              class="tab-pane active"
              role="tabpanel"
            >
              <div class="settings-container__parent-container">
                <div class="settings-container__form col-sm-10">
                  <div class="row">
                    <div class="col col-sm-3 d-none d-sm-block" />
                    <h4 class="settings-container__main-header col-sm-9">
                      Practice Details
                    </h4>
                  </div>
                  <div
                    class="form-group row string required user_first_name"
                    aria-required="true"
                  >
                    <label
                      class="col-sm-3 form-control-label col-form-label string required"
                      for="user_practice_name"
                      aria-required="true"
                    >
                      <span
                        title="required"
                        style="color: red"
                      >*</span>
                      Practice Name
                    </label>
                    <div class="col-sm-8">
                      <input
                        id="user_practice_name"
                        v-model="practice.practiceName"
                        v-validate="'required'"
                        name="practiceName"
                        data-cy="pracName"
                        data-vv-scope="practiceForm"
                        :class="{
                          'is-invalid': errors.first(
                            'practiceForm.practiceName'
                          )
                        }"
                        class="form-control string required valid"
                        autofocus="autofocus"
                        required="required"
                        aria-required="true"
                        type="text"
                        value="Neville"
                        autocomplete="off"
                        aria-invalid="false"
                      >
                      <div
                        data-cy="invalidPracName"
                        class="invalid-feedback"
                      >
                        Please provide your practice name
                      </div>
                    </div>
                  </div>
                  <div class="form-group row password optional user_password">
                    <label
                      class="col-sm-3 form-control-label col-form-label password optional"
                      for="user_password"
                    >
                      <span
                        title="required"
                        style="color: red"
                      >*</span>
                      Profession
                    </label>
                    <div class="col-sm-8">
                      <select
                        id="user_profession"
                        v-model="practice.profession"
                        v-validate="'required'"
                        data-cy="prof"
                        name="profession"
                        data-vv-scope="practiceForm"
                        :class="{
                          'is-invalid': errors.first('practiceForm.profession')
                        }"
                        class="form-control"
                      >
                        <option value="">
                          -
                        </option>
                        <option
                          v-for="type in practitionerTypes"
                          :key="type.value"
                          :value="type.value"
                        >
                          {{ type.text }}
                        </option>
                      </select>
                      <div class="invalid-feedback">
                        Please provide your profession
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="showYourProfessionField"
                    class="form-group row optional"
                  >
                    <label
                      class="col-sm-3 form-control-label col-form-label string"
                      for="other_practice_profession"
                      aria-required="true"
                    >
                      Your Profession
                    </label>
                    <div class="col-sm-8">
                      <input
                        id="user_profession"
                        v-model="practice.profession"
                        name="profession"
                        data-vv-scope="practiceForm"
                        class="form-control string valid"
                        autofocus="autofocus"
                        required="required"
                        aria-required="true"
                        type="text"
                        autocomplete="off"
                        aria-invalid="false"
                        placeholder="Please specify your profession"
                      >
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-sm-3 hidden-sm-down" />
                    <div class="form-actions col-sm-9 offset-sm-3">
                      <input
                        type="submit"
                        data-cy="submit"
                        name="commit"
                        value="Save changes"
                        class="btn btn-primary settings-container__submit-btn mtl"
                        data-disable-with="Save changes"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import { microbaSuccess } from '@microbadevs/notifications'
import Password from '@/components/Password.vue'
import PasswordStrength from 'vue-password-strength-meter'

export default {
  name: 'Account',
  components: {
    Password,
    PasswordStrength
  },
  data () {
    return {
      tab: 'ACCOUNT',
      isPracticeLoading: false,
      practiceUpdated: false,
      isAccountLoading: false,
      accountUpdated: false,
      currentPasswordError: '',
      newPasswordError: '',
      confirmPasswordError: '',
      isValidPassword: false,
      profile: {
        firstName: '',
        lastName: '',
        email: '',
        password: null,
        newPassword: null,
        reEnteredPassword: null,
        userType: 'CONSUMER'
      },
      practice: {
        practiceName: '',
        displayOnWebsite: '',
        displayName: '',
        profession: null,
        clinicAddress: '',
        displayPhone: '',
        displayEmail: '',
        userType: 'HEALTH_CARE_PRACTITIONER'
      },
      defaultPractitionerTypes: [
        { value: 'GASTROENTEROLOGIST', text: 'Gastroenterologist' },
        { value: 'GENERAL_PRACTITIONER', text: 'General Practitioner (GP)' },
        {
          value: 'PSYCHIATRIST_PSYCHOLOGIST',
          text: 'Psychiatrist/Psychologist'
        },
        { value: 'DIETITIAN', text: 'Dietitian' },
        { value: 'NUTRITIONIST', text: 'Nutritionist' },
        { value: 'NATUROPATH', text: 'Naturopath' },
        { value: 'OTHER', text: 'Other (specify below)' }
      ]
    }
  },
  computed: {
    newPasswordOrConfirmPasswordEntered () {
      return Boolean(this.profile.newPassword || this.profile.reEnteredPassword)
    },
    havePasswordErrors () {
      return Boolean(this.currentPasswordError || this.newPasswordError || this.confirmPasswordError)
    },
    isButtonDisabled () {
      return Boolean(this.newPasswordOrConfirmPasswordEntered && this.havePasswordErrors)
    },
    practitionerTypes () {
      const finalPractitionerTypes = this.defaultPractitionerTypes
      let ifUserInExistingProfession = []

      // Check if user is in existing professions
      if (this.practice.profession) {
        ifUserInExistingProfession = finalPractitionerTypes.filter(type => {
          return type.value === this.practice.profession
        })
      }

      // if not, it means user belongs to other profession he created and we put it in profession list.
      if (ifUserInExistingProfession.length === 0) {
        finalPractitionerTypes[
          finalPractitionerTypes.length - 1
        ].value = this.practice.profession
      }
      return finalPractitionerTypes
    },
    showYourProfessionField () {
      // Put all existing professions in an array
      const existingProfessions = this.practitionerTypes
        .slice(0, this.practitionerTypes.length - 1)
        .map(type => type.value)

      // If user has other profession(OTHER or specified profession), show the profession field
      return (
        this.practice.profession === 'OTHER' ||
        existingProfessions.filter(profession => {
          return profession === this.practice.profession
        }).length === 0
      )
    },
    user () {
      return this.$store.state.GET_USER_RESPONSE
    },
    hcp () {
      return this.$store.state.GET_HCP_RESPONSE
    }
  },
  watch: {
    user: {
      handler: function () {
        this.profile = {
          ...this.user,
          password: null,
          newPassword: null,
          userType: 'CONSUMER'
        }
      },
      deep: true
    },
    hcp: {
      handler: function (val) {
        this.practice = {
          practiceName: val.practiceName,
          displayOnWebsite: val.displayOnWebsite === true,
          displayName: val.displayName,
          profession: val.profession,
          clinicAddress: val.clinicAddress,
          displayPhone: val.displayPhone,
          displayEmail: val.displayEmail,
          userType: 'HEALTH_CARE_PRACTITIONER'
        }
      },
      deep: true
    }
  },
  mounted () {
    if (this.user) {
      this.profile = {
        ...this.user,
        password: null,
        newPassword: null,
        userType: 'CONSUMER'
      }
    }
    if (this.hcp) {
      const val = this.hcp
      this.practice = {
        practiceName: val.practiceName,
        displayOnWebsite: val.displayOnWebsite === true,
        displayName: val.displayName,
        profession: val.profession,
        clinicAddress: val.clinicAddress,
        displayPhone: val.displayPhone,
        displayEmail: val.displayEmail,
        userType: 'HEALTH_CARE_PRACTITIONER'
      }
    }
  },
  methods: {
    resetValidationMessage () {
      this.currentPasswordError = ''
      this.newPasswordError = ''
      this.confirmPasswordError = ''
    },
    passwordValidation (validationResult) {
      const { isValid, source, validationMessage } = validationResult
      this.resetValidationMessage()
      this.isValidPassword = isValid
      if (this.isValidPassword && !this.profile.password) this.currentPasswordError = 'Please enter the current password.'
      if (source === 'newPassword') this.newPasswordError = validationResult.validationMessage
      else this.confirmPasswordError = validationMessage
    },
    saveAccount () {
      if (this.profile.password && !this.profile.newPassword && !this.profile.reEnteredPassword) {
        this.currentPasswordError = 'New password must not be empty when password is provided. Please clear it.'
        return
      }
      this.$validator.validate('profileForm.*').then(() => {
        if (this.isAccountLoading || this.errors.any()) return
        this.accountUpdated = false
        const payload = this.profile
        this.$store
          .dispatch('putUser', payload)
          .then(() => {
            this.accountUpdated = true
            this.resetValidationMessage()
            microbaSuccess({ text: 'Saved successfully.' })
          })
          .catch(error => {
            if (error.response.status === 403) {
              this.currentPasswordError = 'Please enter the correct current password.'
            } else {
              throw new Error(error)
            }
          })
          .finally(() => {
            this.isAccountLoading = false
          })
      })
    },
    savePractice () {
      this.$validator.validate('practiceForm.*').then(() => {
        if (!this.errors.any()) {
          if (this.isPracticeLoading) return

          this.practiceUpdated = false
          const payload = Object.assign(this.hcp, this.practice)
          this.$store
            .dispatch('putPractice', payload)
            .then(() => {
              this.practiceUpdated = true
              microbaSuccess({ text: 'Saved successfully.' })
            })
            .finally(() => {
              this.isPracticeLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .settings-container .nav-tabs {
    flex-wrap: nowrap;

    .nav-item {
      margin-bottom: 0;
      border-right: 1px solid #c4ced1;
    }
  }

  .settings-container__nav-link {
    padding: 10px 20px;
    font-size: 14px;
    color: #6c7279;
    background: #e2e6e8;
    border-radius: 0;

    .active {
      background: white !important;
      border: none !important;
      padding-top: 12px;
      margin-top: -2px;
      border-radius: 3px 3px 0 0 !important;
    }
  }

  .settings-container__tab-container {
    border-bottom: none;
    margin: 0;
    padding-top: 2px;
  }

  .settings-container__parent-container {
    border-top: none;
    background: white;
    padding: 100px;
  }

  .settings-container__form {
    margin: 0 auto;
    padding: 0;
  }

  .settings-container__main-header {
    font-size: 22px;
    padding: 20px 15px;
  }

  .settings-container__main-header,
  .settings-container__sub-header {
    font-weight: 300;
  }

  .form-control-label {
    text-align: right;
    white-space: nowrap;
    direction: rtl;
  }
  .settings-container .form-control {
    color: #6c7279;
    font-size: 14px;
  }
</style>
